<template>
    <div
        class="user-icon"
        :style="calculateUsernameColor(user.username)">
        <span>{{ firstInitial }}</span>
    </div>
</template>

<script>
import { calculateUsernameColor, formatUserFullName } from '@utils/user-settings';

export default {
    name: 'UserIcon',
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    computed: {
        firstInitial () {
            return formatUserFullName(this.user)
                .charAt(0)
                .toUpperCase();
        },
    },
    methods: {
        calculateUsernameColor,
    },
};
</script>

<style scoped lang="less">
.user-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    font-weight: 500;
    border-width: 1.5px;
    border-style: solid;
}
</style>
